import React, { PropsWithChildren, useRef, useState } from 'react';
import './ContentPreviewer.scss';
import { ContentLinkify } from './ContentLinkify';
import { useResizeObserver } from '@react-aria/utils';
import { SalvButton, Size } from '@salvapp/ui-components';

interface Props {
  previewLinesAmount?: number;
}

export const ContentPreviewer = ({ children, previewLinesAmount = 1 }: PropsWithChildren<Props>) => {
  const [isExpanded, setExpanded] = useState(false);
  const [isContentBiggerThanPreview, setContentIsBiggerThanPreview] = useState(false);

  const contentRef = useRef<HTMLDivElement>(null);

  useResizeObserver({
    ref: contentRef,
    onResize: () => {
      requestAnimationFrame(() => {
        if (!contentRef.current || isExpanded) {
          return;
        }

        const style = window.getComputedStyle(contentRef.current);

        const maxPreviewHeight = previewLinesAmount * parseFloat(style.lineHeight);
        const contentHeight = parseFloat(style.height);

        if (contentHeight > maxPreviewHeight) {
          contentRef.current.style.maxHeight = maxPreviewHeight + 'px';
          setContentIsBiggerThanPreview(true);
        }
      });
    },
  });

  const toggleExpansion = () => {
    if (!contentRef.current) {
      return;
    }

    contentRef.current.style.maxHeight = 'none';
    setExpanded(true);
  };

  return (
    <div className='content-preview' ref={contentRef}>
      <ContentLinkify>{children}</ContentLinkify>
      {!isExpanded && isContentBiggerThanPreview && (
        <div className='expand-content-button p-l-12'>
          <SalvButton onClick={toggleExpansion} label={'More…'} size={Size.SMALL} />
        </div>
      )}
    </div>
  );
};
